module.exports = __webpack_public_path__ + "img/tertiary_4x4_z18.6f1181bc.svg";